import {useSelector} from 'react-redux';
import {tabletScreen} from '../globalVariables/GlobalVariables';

const useTablet= ()=>(useSelector(s=>s.ui.windowWidth))<tabletScreen;

export default useTablet;